import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    cvv: {
      fontFamily: 'caption',
      letterSpacing: 5,
      fontSize: 19,
    },
    paymentError: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      padding: '20px 0',
      color: theme.oysterTheme.ferrari,
      '& .MuiSvgIcon-root': {
        marginRight: 10,
      },
    },
    logoPartnerContainer: {
      width: '100%',
      textAlign: 'center',
      marginTop: theme.spacing(1),
    },
    disclaimer: {
      fontSize: 12,
      color: theme.oysterTheme.shark,
      '& a': {
        fontSize: 12,
        color: ({ secondaryColor }) => secondaryColor,
      },
    },
    noteInfo: {
      marginTop: 20,
      padding: 12,
      fontSize: 14,
      fontWeight: 400,
      color: '#011B34',
      lineHeight: '20px',
      borderRadius: 8,
      backgroundColor: 'rgba(24, 144, 255, .10)',
    },
  }),
);

export default useStyles;
